<div class="app-shell" [class.is-collapsed]="isSidebarCollapsed">
  <app-sidenav [collapsed]="isSidebarCollapsed" (closed)="isSidebarCollapsed = true"></app-sidenav>

  <div class="app-content">
    <header class="app-topbar">
      <button class="sidebar-toggle" type="button" (click)="toggleSidebar()" aria-label="Plegar panel lateral">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
          stroke-linejoin="round">
          <rect x="4" y="4" width="16" height="16" rx="3"></rect>
          <path d="M10 4v16"></path>
        </svg>
      </button>
      <div class="welcome">
        Bienvenido, <span>{{ userName }}</span>
      </div>
    </header>

    <main class="app-main">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<div
  *ngIf="!isSidebarCollapsed"
  class="sidebar-overlay"
  (click)="toggleSidebar()"
  aria-hidden="true"
></div>

<button
  class="sidebar-handle"
  type="button"
  aria-label="Abrir panel lateral"
  (click)="toggleSidebar()"
>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <polyline points="9 6 15 12 9 18"></polyline>
  </svg>
</button>

<ngx-spinner
  [name]="spinnerName"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true">
  <p style="color: white"> Cargando... </p>
</ngx-spinner>
